import { Footer } from "../../../Components/Footer/Footer"
import { Navbar } from "../../../Components/Navbar/Navbar"
import { Communication } from "../../../Components/Services/Components/Communication/Communication"

export const Pages_Communication = () => {
    return (
        <>
            <Navbar />
            <Communication />
            <Footer />
        </>
    )
}